// ------------------------------------
// Constants
// ------------------------------------
export const HANDLE_VIEW = 'inf/signup/HANDLE_VIEW'
export const LOAD_SIGNUP = 'inf/signup/LOAD_SIGNUP'
export const RECEIVE_SIGNUPS = 'inf/signup/RECEIVE_SIGNUPS'



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/signup/constants.js